import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
// Side-effect import: installs the global axios Bearer interceptor + withCredentials
// so it's always active regardless of which route the user lands on first.
import "./services/api";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import NewHome from "./pages/NewHome";
import NewTalentos from "./pages/NewTalentos";
import AdminPanel from "./pages/AdminPanel";
import Dashboard from "./pages/Dashboard";
import InfluencersCRM from "./pages/InfluencersCRM";
import PropuestasApp from "./pages/PropuestasApp";
import HubPanel from "./pages/HubPanel";
import { Toaster } from "./components/ui/toaster";

const Layout = () => {
  const location = useLocation();
  // Everything under /panel/* is a private internal module: no public navbar/footer.
  const hideChrome = location.pathname === '/panel' || location.pathname.startsWith('/panel/');

  return (
    <>
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<NewHome />} />
        <Route path="/talentos" element={<NewTalentos />} />

        {/* Unified Hub — single entry point for all internal modules */}
        <Route path="/panel" element={<HubPanel />} />
        <Route path="/panel/admin" element={<AdminPanel />} />
        <Route path="/panel/vtas" element={<Dashboard />} />
        <Route path="/panel/influs" element={<InfluencersCRM />} />
        <Route path="/panel/propuestas" element={<PropuestasApp />} />

        {/* Legacy routes → redirect to hub. Preserves ?query and #hash so
            deep-links like /vtas?tab=edr keep working under /panel/vtas. */}
        <Route path="/admin" element={<Navigate to="/panel/admin" replace />} />
        <Route path="/vtas" element={<Navigate to="/panel/vtas" replace />} />
        <Route path="/influs" element={<Navigate to="/panel/influs" replace />} />
        <Route path="/propuestas" element={<Navigate to="/panel/propuestas" replace />} />
      </Routes>
      {!hideChrome && <Footer />}
      <Toaster />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}

export default App;
